
import { defineComponent, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { themeLightLogo } from "@/core/helpers/config";

export default defineComponent({
  name: "auth",
  components: {},
  setup() {
    const store = useStore();

    onMounted(() => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
    });

    onUnmounted(() => {
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
    });

    //const logo: string = themeLightLogo.value;
    const logo = themeLightLogo.value;
    let year = new Date().getFullYear();
    return {
      logo,
      year,
    };
  },
});
